
import LHomeMain from "@/pages/landingpage/home-main";
import JoinUsPage from "@/pages/landingpage/join-us-page";
import LPageAbout from "@/pages/landingpage/page-about";
import LPageContact from "@/pages/landingpage/page-contact";
import LPageConsultationRequests from "@/pages/landingpage/page-consultation-requests";
import LPageServices from "@/pages/landingpage/page-services";
import LPageServicesDetails from "@/pages/landingpage/page-services-details";
import LPageError from "../pages/error-page";
import AuthLayout from "@/layouts/AuthLayout";
import LoginPage from "@/pages/auth/page-login";
import AdminDashboard from "@/pages/admin/dashboard/AdminDashboard";
import AdminUsers from "@/pages/admin/users/AdminUsers.tsx";
import AdminLayout from "@/layouts/AdminLayout";
import AdminMessages from "@/pages/admin/messages/Messages";
import AdminApplications from "@/pages/admin/job_applications/JobApplications";
import AIUnitService from "@/pages/landingpage/services-pages/AI-unit/AIUnit";
import DevelopmentService from "@/pages/landingpage/services-pages/dev-encryption/DevEncryption";
import DigitalAssets from "@/pages/landingpage/services-pages/digital-assets/DigitalAssets";
import Consultations from "@/pages/landingpage/services-pages/consultations/Consultations";
import AdminDepartments from "@/pages/admin/departments/Departments";
import AdminNationalities from "@/pages/admin/nationalities/Nationalities";
import AdminTrainees from "@/pages/admin/Trainees/Trainnes";

// Template
import Project1 from "@/pages/landingpage/services-pages/project1/Project1";
import Project2 from "@/pages/landingpage/services-pages/project2/Project2";
import Project3 from "@/pages/landingpage/services-pages/project1/Project1";



export const Router = [

  { path: "/", element: <LHomeMain /> },
  { path: "/about", element: <LPageAbout /> },
  { path: "/contact", element: <LPageContact /> },
  { path: "/consultaion-requests", element: <LPageConsultationRequests /> },
  { path: "/services", element: <LPageServices /> },
  { path: "/services-details/:id", element: <LPageServicesDetails /> },
  { path: "/join-the-team", element: <JoinUsPage /> },
  { path: "/services/artificial-intelligence", element: <AIUnitService /> },
  { path: "/services/development-encryption", element: <DevelopmentService /> },
  { path: "/services/digital-assets", element: <DigitalAssets /> },
  { path: "/services/consultations", element: <Consultations /> },

  // Template
  { path: "/project1", element: <Project1 /> },
  { path: "/project2", element: <Project2 /> },
  { path: "/project3", element: <Project3 /> },
  {
    path: '/',
    element: <AuthLayout/>,
    children: [
      { path: '/auth/login', element: <LoginPage /> },
    ],
  },
  {
    path: '/',
    element: <AdminLayout/>,
    children: [
      { path: '/admin/dashboard', element: <AdminDashboard /> },
      { path: '/admin/users', element: <AdminUsers /> },
      { path: '/admin/job-applications', element: <AdminApplications /> },
      { path: '/admin/consultation-requerst', element: <AdminMessages /> },
      { path: '/admin/messages', element: <AdminMessages /> },
      { path: '/admin/nationalities', element: <AdminNationalities /> },
      { path: '/admin/application-departments', element: <AdminDepartments /> },
      { path: '/admin/trainees', element: <AdminTrainees /> },
    ],
  },
  { path: "/*", element: <LPageError /> },
];
